/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedUserListListResponse } from '../types/PaginatedUserListList';
import type { Roles } from '../types/Roles';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type UsersListRequest = {} | null | undefined;
export type UsersListResponse = PaginatedUserListListResponse;

export type UsersListQuery = {
  /**
   * ```yaml
   * in: query
   * name: ico__icontains
   * schema:
   *   type: string
   * ```
   */
  ico__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: is_active
   * schema:
   *   type: boolean
   * ```
   */
  is_active?: boolean;

  /**
   * ```yaml
   * in: query
   * name: is_editor
   * schema:
   *   type: boolean
   * ```
   */
  is_editor?: boolean;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: roles
   * schema:
   *   type: array
   *   items:
   *     type: integer
   *     enum:
   *       - ADMIN
   *       - MANAGER_EDITOR
   *       - MANAGER_MANAGER
   *       - MANAGER_SUPERVISOR
   *       - PREJIMKA_RECEIVER
   *       - PREJIMKA_USER
   *       - Spravce_DTI_DMVS
   *       - Spravce_dat_DI
   *       - Spravce_dat_TI
   *       - VYDEJ_APPROVER
   *       - VYDEJ_KRAJ
   *       - VYDEJ_MANAGER
   *       - VYDEJ_ORP
   *       - VYDEJ_USER
   * description: |-
   *   roles
   *
   *   * `ADMIN` - Admin
   *   * `VYDEJ_MANAGER` - Manažer výdeje
   *   * `VYDEJ_KRAJ` - Kraj
   *   * `VYDEJ_ORP` - ORP
   *   * `PREJIMKA_USER` - Uživatel přejímky
   *   * `PREJIMKA_RECEIVER` - Zpracovatel přejímky
   *   * `MANAGER_MANAGER` - Manažer přejímky
   *   * `MANAGER_SUPERVISOR` - Správce přejímky
   *   * `MANAGER_EDITOR` - Editor přejímky
   *   * `VYDEJ_USER` - Uživatel výdeje
   *   * `Spravce_DTI_DMVS` - Správce DTI DMVS
   *   * `Spravce_dat_DI` - Správce dat DI
   *   * `Spravce_dat_TI` - Správce dat TI
   *   * `VYDEJ_APPROVER` - Schvalovatel výdeje
   * explode: true
   * style: form
   * ```
   */
  roles?: Roles[];

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;
};

/**
 * GET /dmx-server/users/
 *
 * ```yaml
 * operationId: users_list
 * tags:
 *   - users
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedUserListList'
 *     description: ''
 * ```
 */
export const usersListOperation = (rest?: UsersListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/users/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/users/' };
  };

/**
 * GET /dmx-server/users/
 *
 * ```yaml
 * operationId: users_list
 * tags:
 *   - users
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedUserListList'
 *     description: ''
 * ```
 */
export const usersList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: UsersListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedUserListListResponse>> => {
  const operation = usersListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/users/
 */
export const useUsersListResource = (
  query: UsersListQuery | null,
  useCached?: boolean,
): UseResource<UsersListResponse> => {
  return useResource<UsersListResponse>({
    path: query === null ? null : usersListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
